<template>
  <div class="card-selection">
    <div class="scrollable no-scrollbar" ref="container">
      <div class="flex-row">
        <div
          v-for="card in options"
          class="choice flex-column"
          @click="click(card._id)"
          :key="card._id"
          :data-class="card._id"
          ref="optionElements"
        >
          <img :src="card.image" :width="width" :height="height" />
          <div class="textual-content">
            <div class="card-stripe flex-row">
              <img
                :src="getManufacturerByID(card.manufacturerRef).logo"
                width="40px"
                height="40px"
                class="logo"
              />
              <div class="names flex-column">
                <h1 v-text="card.name" v-show="card.name"></h1>
                <p v-show="card.manufacturerRef" v-text="getManufacturerByID(card.manufacturerRef).name"></p>
              </div>
            </div>
            <p class="brief" v-text="card.brief"></p>
          </div>
          <div class="overlay">
            <i class="fas fa-check-circle"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="button-set">
      <div
        @click="moveRight"
        ref="rightArrow"
        :class="{ arrow: true, 'arrow-right': true, hide: hideRight }"
      >
        <i class="fa fa-chevron-right"></i>
      </div>
      <div
        @click="moveLeft"
        ref="leftArrow"
        :class="{ arrow: true, 'arrow-left': true, hide: hideLeft }"
      >
        <i class="fa fa-chevron-left"></i>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  props: {
    "single-answer": Boolean,
    "multiple-answer": Boolean,
    // scrollable: Boolean,
    options: { type: Array, required: true },
    width: { type: String, default: "320" },
    height: String,
    value: { type: Array },
  },
  data() {
    return {
      scrollable: null,
      hideLeft: false,
      hideRight: false,
    };
  },
  mounted() {
    this.scrollable = this.$refs.container;
    this.onScroll();
    this.updateActives();
    this.scrollable.addEventListener("scroll", this.onScroll);
    window.addEventListener("resize", this.onResize);
  },
  deactivated() {
    this.scrollable.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
  },
  computed: mapGetters(['getManufacturerByID']),
  methods: {
    click(option) {
      if (this.multipleAnswer) {
        this.toggle(option);
      } else if (this.singleAnswer) {
        this.choose(option);
      } else {
        console.warn(
          "multiple-choice without answer type specification 'multiple-answer' or 'single-answer'"
        );
        this.choose(option);
      }
    },
    toggle(option) {
      let newArray;
      if (this.value.some((item) => item === option)) {
        newArray = this.value.filter((item) => item !== option);
      } else {
        newArray = [...this.value, option];
      }
      this.$emit("input", newArray);
    },
    choose(option) {
      const newArray = option;
      this.$emit("input", newArray);
    },
    updateActives() {
      if (this.options.length <= 0) return;
      this.$refs.optionElements.forEach((element) => {
        if (this.value.includes(element.dataset.class)) {
          element.classList.add("active");
        } else {
          element.classList.remove("active");
        }
      });
    },
    moveRight() {
      this.scrollable.scrollLeft += (2 * this.scrollable.clientWidth) / 3;
    },
    moveLeft() {
      this.scrollable.scrollLeft -= (2 * this.scrollable.clientWidth) / 3;
    },
    onScroll() {
      const left = this.scrollable.scrollLeft;
      const scrollWidth = this.scrollable.scrollWidth;
      const clientWidth = this.scrollable.clientWidth;

      if (left === 0) {
        this.hideLeft = true;
      } else {
        this.hideLeft = false;
      }
      //console.log("onScroll", left, scrollWidth, clientWidth);
      if (left === scrollWidth - clientWidth) {
        this.hideRight = true;
      } else {
        this.hideRight = false;
      }
    },
    onResize() {
      this.onScroll(); // actually scroll detects both ends, it just need to be called on resize.
      /*      
      const scrollWidth = this.scrollable.scrollWidth;
      const clientWidth = this.scrollable.clientWidth;
      console.log("resize", scrollWidth, clientWidth);
      if (scrollWidth === clientWidth) { //no scrollbar*
        this.hideLeft = this.hideRight = false;
      } else {
        this.onScroll();
      }*/
    },
    selectByIndex(index) {
      if (index < this.options.length) {
        this.choose(this.options[index]._id);
      }
    },
    onEdit(card) {
      this.$emit("editCard", card);
    },
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.updateActives();
      },
    },
  },
};
</script>

<style lang="scss">
.card-selection {
  position: relative;
  .arrow {
    position: absolute;
    width: 56px;
    height: 56px;
    background-color: $primary-color;
    text-align: center;
    border-radius: 50%;
    z-index: 2;
    top: 50%;
    transform: translateY(-50%);
    opacity: 1;
    transition: opacity 500ms ease-out;
    box-shadow: 0px 5px 3px 0px rgba($color: #000000, $alpha: 0.08);

    &.hide {
      opacity: 0;
    }
    i {
      color: white;
      font-size: 20px;
      line-height: 56px;
      margin: auto;
    }
    &.arrow-right {
      right: 0;
    }
    &.arrow-left {
      left: 0;
    }
  }
  .scrollable {
    scroll-behavior: smooth;
    overflow: auto;
  }

  .choice {
    margin: 0 10px;
    position: relative;
    background: white;

    .textual-content {
      margin: 10px;
    }

    .brief {
      //color: $secondary-color;
      color: #00000099;
    }

    .card-stripe {
      margin: 12px 0;
      img.logo {
        padding-right: 10px;
      }
      .names {
        h1 {
          flex-grow: 0;
          margin: 0;
        }
        p {
          flex-grow: 0;
          margin: 0;
        }
      }
    }
  }
  .overlay {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba($color: $primary-color, $alpha: 0.12);
    i {
      float: right;
      padding: 6px 6px;
      color: $primary-color;
      font-size: 1.5em;
    }
  }

  .choice.active .overlay {
    display: block;
  }
}
</style>
